console.log('✅ main-search-page-component.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';
import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
import {
  getLinksTranslationByKey,
  getLinksTranslationByKeySingleWord,
} from '../../js/router-routes-manager.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentBasicListingCard } from '../cards/basic-listing-card.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import { convertStringAmountToCurrencyAndSignDirectionForLanguage } from '../../js/utils-convert-currency.js';
import { convertNumberStringFromUKFormatToAnyLanguageFormatDouble } from '../../js/utils-convert-numbers.js';

import {
  buildComponentBasicBottomPagination,
  attachEventListenersBasicBottomPagination,
} from '../pagination-controls/basic-bottom-pagination.js';
import {
  buildComponentMainSearchPageFilter,
  attachEventListenersMainSearchPageFilter,
} from '../main-search-page-component/main-search-page-component-sidebar-filters.js';

import { LRUCacheWithTTL } from '../../js/utils-cache.js';
import { searchPageComponentSharedState } from '../main-search-page-component/main-search-page-component-shared-state.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';

import { initLinksTranslator } from '../../js/router-routes-manager.js';

//let searchRequestModel = {

//    SearchString: "",
//    MaxPrice: "",
//    MinPrice: "",
//    MinMOQ: "",
//    MaxMOQ: "",
//    ListOfSpecOptionsIDs: "",
//    ListOfSpecIDs: "",
//    ListOfDepartmentIDs: "",
//    ListOfCategoryIDs: "",
//    ListOfProductIDs: "",
//    CanBuyNow: "",
//    CanRentOrLease: "",
//    ListOfUnitOfMeasureIDs: "",
//    GroupSearchResult: "",
//    IsProducer: "",
//    ListOfSupplierTypeID: "",
//    IsWholeseller: "",
//    ListOfSellerLevel: "",
//    OfferCustomLogo: "",
//    OfferCustomPackaging: "",
//    OfferProductRedesign: "",
//    ListOfShippedFromCountryID: "",
//    ListOfCountryOfOriginID: "",
//    ListOfCountryOfSellerID: "",
//    IsTrending: "",
//    IsFeatured: "",
//    ListOfBuyingCompanyID: "",
//    LanguageCode: "",
//    OrderByDirection: "",
//    PageNumber: "",
//    NumberOfResultsToReturnPerPage: "",
//    SelectedCountryID: "",
//    SelectedStateID: "",
//    SelectedCityID: "",
//    SearchLoggedInUserID: "",
//    SearchBuyingEntityID: "",
//    SearchBuyingEntityType: "",

//}

/**
 * 
{
  "searchString": "",
  "returnType": "listingsID",
  "maxPrice": "",
  "minPrice": "",
  "minMOQ": "",
  "maxMOQ": "",
  "listOfSpecOptionsIDs": "",
  "listOfSpecIDs": "",
  "listOfDepartmentIDs": "",
  "listOfCategoryIDs": "",
  "listOfProductIDs": "",
  "canBuyNow": "",
  "canRentOrLease": "",
  "listOfUnitOfMeasureIDs": "",
  "groupSearchResult": "",
  "isProducer": "",
  "listOfSupplierTypeID": "",

  "isWholeseller": "",
  "listOfSellerLevel": "",
  "offerCustomLogo": "",
  "offerCustomPackaging": "",
  "offerProductRedesign": "",
  "listOfShippedFromCountryID": "",
  "listOfCountryOfOriginID": "",
  "listOfCountryOfSellerID": "",
  "isTrending": "",
  "isFeatured": "",
  "listOfBuyingCompanyID": "",
  "languageCode": "",
  "orderByDirection": "",
  "pageNumber": "",
  "numberOfResultsToReturnPerPage": "",
  "selectedCountryID": "",
  "selectedStateID": "",
  "selectedCityID": "",
  "searchLoggedInUserID": "",
  "searchBuyingEntityID": "",
  "searchBuyingEntityType": ""
}



 {
  "searchString": "",
  "maxPrice": null,
  "minPrice": null,
  "minMOQ": null,
  "maxMOQ": null,
  "listOfSpecOptionsIDs": null,
  "listOfSpecIDs": null,
  "listOfDepartmentIDs": null,
  "listOfCategoryIDs": null,
  "listOfProductIDs": null,
  "canBuyNow": null,
  "canRentOrLease": null,
  "listOfUnitOfMeasureIDs": null,
  "groupSearchResult": "True",
  "isProducer": null,
  "listOfSupplierTypeID": null,

  "isWholeseller": null,
  "listOfSellerLevel": null,
  "offerCustomLogo": null,
  "offerCustomPackaging": null,
  "offerProductRedesign": null,
  "listOfShippedFromCountryID": null,
  "listOfCountryOfOriginID": null,
  "listOfCountryOfSellerID": null,
  "isTrending": null,
  "isFeatured": null,
  "listOfBuyingCompanyID": "",
  "languageCode": "",
  "orderByDirection": "",
  "pageNumber": "1",
  "numberOfResultsToReturnPerPage": "6",
  "selectedCountryID": "",
  "selectedStateID": "",
  "selectedCityID": "",
  "searchLoggedInUserID": "",
  "searchBuyingEntityID": "",
  "searchBuyingEntityType": ""
}




 */

let _tempTextTranslator = null;

export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

export async function buildComponentMainSearchPageComponent(params, valuesInUrl, layoutType) {
  // get the list of filters from the appState
  searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters = JSON.parse(
    JSON.stringify(appState.ListOfSpecOptionsSelectedFilters)
  );

  const lang = appState.SiteLanguageCookie;

  console.log(
      `🔄 Building Component: CatalogProducts - lang: ${lang},  layoutType: ${layoutType}  valuesInUrl: ${valuesInUrl}  params: ${params} `
  );

  //const layoutType = "allProducts"; // search // allProducts //product

  try {
    await initTempTextTranslator(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyAllProducts: lblAllProducts,
      keyGroupRelatedItems: lblGroupRelatedItems,
      keyResults: lblResults,
      keySortBy: lblSortBy,
      keyFilters: lblFilters,
      keyRelevance: lblRelevance,
      keySortDropDownPriceLowToHigh: lblPriceLowToHigh,
      keySortDropDownPriceHighToLow: lblPriceHighToLow,
      keyRatings: lblRatings,
      keyHome: lblHome,
      keySearch: lblSearch,
      keySearchResults,
      lblSearchResults,
    } = _tempTextTranslator;

    let specificProductDetails = {};

    let departmentID = '';
    let departmentSEOPageName = '';
    let categoryID = '';
    let categorySEOPageName = '';
    let productID = '';
    let productSEOPageName = '';

    let departmentLinkForProduct = '';
    let categoryLinkForProduct = '';
    let productLinkForProduct = '';

    let departmentNameForProduct = '';
    let categoryNameForProduct = '';
    let productNameForProduct = '';

    if (layoutType === 'product') {
      // params like params: 17,clothes-shoes,1,womens-clothing,127,dresses

       

      //get the values from the params
      const valuesNeeded = params.split(',');
      departmentID = valuesNeeded[0];
      departmentSEOPageName = valuesNeeded[1];
      categoryID = valuesNeeded[2];
      categorySEOPageName = valuesNeeded[3];
      productID = valuesNeeded[4];
      productSEOPageName = valuesNeeded[5];

      // Fetch the specific product details
      specificProductDetails = await fetchProductDetailsWithCategoryDetailsAndDepartmentDetailsByID(
        productID,
        categoryID,
        departmentID
      );

      departmentLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}`;
      categoryLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}/${specificProductDetails.currentCategoryID}/${specificProductDetails.currentCategorySEOPageName}`;

      productLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}/${specificProductDetails.currentCategoryID}/${specificProductDetails.currentCategorySEOPageName}/${specificProductDetails.productID}/${specificProductDetails.seoPageName}`;

      departmentNameForProduct = specificProductDetails.currentDepartmentName;
      categoryNameForProduct = specificProductDetails.currentCategoryName;
      productNameForProduct = specificProductDetails.name;

      searchPageComponentSharedState.layoutType = 'product';
      searchPageComponentSharedState.currentProductID = productID;
    }

    let text1 = '';
    let link1 = '';
    let text2 = '';
    let link2 = '';
    let text3 = '';
    let link3 = '';
    let text4 = '';
    let link4 = '';
    let text5 = '';
    let link5 = '';

    if (layoutType === 'search') {
      text1 = lblHome;
      link1 = '/';
      text2 = lblSearch;
      link2 = '';
      text3 = '';
      link3 = '';
      text4 = '';
      link4 = '';
      text5 = '';
      link5 = '';
    } else if (layoutType === 'allProducts') {
      text1 = lblHome;
      link1 = '/';
      text2 = lblAllProducts;
      link2 = '';
      text3 = '';
      link3 = '';
      text4 = '';
      link4 = '';
      text5 = '';
      link5 = '';
    } else if (layoutType === 'product') {
      text1 = lblHome;
      link1 = '/';
      text2 = departmentNameForProduct;
      link2 = departmentLinkForProduct;
      text3 = categoryNameForProduct;
      link3 = categoryLinkForProduct;
      text4 = productNameForProduct;
      link4 = '';
      text5 = '';
      link5 = '';
    }

    const breadCrumbHtmlSpan = await buildComponentBreadcrumb(
      text1,
      link1,
      text2,
      link2,
      text3,
      link3,
      text4,
      link4,
      text5,
      link5
    );

    //get the query parameters values from valuesInUrl
    //page=4&size=6&sort=price
    const urlParams = new URLSearchParams(valuesInUrl);
    const pageFromURL = urlParams.get('page');
    const pageSizeFromURL = urlParams.get('size');
    const sortTypeFromURL = urlParams.get('sort');
    const searchStringFromURL = urlParams.get('searchString');

    if (pageFromURL) {
      searchPageComponentSharedState.searchRequestModel.PageNumber = pageFromURL.toString();
    } else {
      searchPageComponentSharedState.searchRequestModel.PageNumber = '1';
    }

    if (pageSizeFromURL) {
      searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage = validateNumberOfResultsToReturnPerPage(
        pageSizeFromURL.toString()
      );
    } else {
      searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage = validateNumberOfResultsToReturnPerPage(
        appState.SearchSettingsItemsPerPage
      );
    }

    if (sortTypeFromURL) {
      searchPageComponentSharedState.searchRequestModel.OrderByDirection = validateSortByValue(
        sortTypeFromURL.toString()
      );
    } else {
      searchPageComponentSharedState.searchRequestModel.OrderByDirection = validateSortByValue(
        appState.SearchSettingsSortBy
      );
    }

    if (searchStringFromURL) {
      searchPageComponentSharedState.searchRequestModel.SearchString = searchStringFromURL.toString();
    }

    searchPageComponentSharedState.searchRequestModel.GroupSearchResult = appState.SearchSettingsGroupRelated
      ? 'True'
      : 'False';

    //check if the group search result is set to true or false
    if (searchPageComponentSharedState.searchRequestModel.GroupSearchResult === '') {
      searchPageComponentSharedState.searchRequestModel.GroupSearchResult = 'True';
    }

    searchPageComponentSharedState.searchRequestModel.LanguageCode = lang;

    searchPageComponentSharedState.searchRequestModel.SelectedCountryID =
      appState.SiteShipToCountryIDCookie;
    searchPageComponentSharedState.searchRequestModel.SelectedStateID =
      appState.SiteShipToStateIDCookie;
    searchPageComponentSharedState.searchRequestModel.SelectedCityID =
      appState.SiteShipToCityIDCookie;

    searchPageComponentSharedState.searchRequestModel.SearchLoggedInUserID =
      appState.MyLoggedInUserID;
    searchPageComponentSharedState.searchRequestModel.SearchBuyingEntityID =
      appState.MyBuyingEntityID;
    searchPageComponentSharedState.searchRequestModel.SearchBuyingEntityType =
      appState.MyBuyingEntityType;

    // alert(valuesInUrl);
    // alert(pageFromURL);
    // alert(searchRequestModel.PageNumber);

    // alert(searchRequestModel.GroupSearchResult);

    //  let currentUrlForBottomNavigation = "";

    const allListingsAsHtmlLoading = await renderListingsHtmlLoading();

    // const renderSideBarAsHTML = await renderSidebarFiltersAsHtml(lang);; // Set to true to render the sidebar filters

    const renderSideBarAsHTML = await buildComponentMainSearchPageFilter(lang, layoutType); // Set to true to render the sidebar filters

    let renderTopSectionAsHTML = '';

    if (layoutType === 'search') {
      renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlSearch(); // Set to true to render the main result to section
      //  currentUrlForBottomNavigation = await getLinksTranslationByKey("keySearch", lang); // Set to true to render the main result to section
    } else if (layoutType === 'allProducts') {
      renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlProducts(); // Set to true to render the main result to section
      //   currentUrlForBottomNavigation = await getLinksTranslationByKey("keyProducts", lang); // Set to true to render the main result to section
    } else if (layoutType === 'product') {
      renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlProduct(productNameForProduct); // Set to true to render the main result to section
      // currentUrlForBottomNavigation = "tbc"; // Set to true to render the main result to section
    }

    const renderTopMiddleSectionWithTheSortingAndFiltersAsHTML = await generateTopMiddleSectionWithSortingAndFiltersAsHTML(
      lblSortBy,
      lblRelevance,
      lblPriceLowToHigh,
      lblPriceHighToLow,
      lblRatings,
      lblFilters,
      lblResults
    ); // Set to true to render the main result to section
    const renderTopMiddleSectionWithTheSortingAndFiltersAsHTMLMobile = await generateTopMiddleSectionWithSortingAndFiltersAsHTMLMobile(
      lblSortBy,
      lblRelevance,
      lblPriceLowToHigh,
      lblPriceHighToLow,
      lblRatings,
      lblFilters,
      lblResults
    ); // Set to true to render the main result to section

    //const renderTopMiddleSectionWithTheSortingAndFiltersAsHTML = await generateTopMiddleSectionWithTheSortingAndFiltersAsHTML(lang); // Set to true to render the main result to section
    //const renderTopMiddleSectionWithTheSortingAndFiltersAsHTMLMobile = await generateTopMiddleSectionWithTheSortingAndFiltersAsHTMLMobile(lang); // Set to true to render the main result to section

    const renderBottonNavigationAsHTML = '';

    // Build the products HTML
    const html = `
            <center>
                <div class="myPageMargins">

                ${breadCrumbHtmlSpan}
                <br>

                  <div class="MainContentContainer-Regular MasterLayoutMargins-RegularContainer">


            <div class="basicPageRow">

                <div id="wholeSideBarContent" class="my-basic-width-flex-25  temp-flex-25-override class-filter-collpased"  style="border-right: 1px solid rgb(216, 216, 216);">

               
               
                  ${renderSideBarAsHTML}
                 
        


     </div>

       <!-- Start 75% Flex Section -->

                  <div id="mainSearchContentHolder" class="my-basic-width-flex-75">

                       
                          ${renderTopMiddleSectionWithTheSortingAndFiltersAsHTMLMobile}

                        
                         
                         

                          <div class="searchPageContainer">

       ${renderTopSectionAsHTML}

                         

                        <input type="checkbox" name="checkbox" id="ckGroupByListing" ${
                          appState.SearchSettingsGroupRelated ? 'checked' : ``
                        } > <label for="ckGroupByListing">   ${lblGroupRelatedItems}</label>

                          </div>


         ${renderTopMiddleSectionWithTheSortingAndFiltersAsHTML}
       
      

                           




                        <!-- Start Section -->

                          <div id="product-results" class="ProductListContainer">

                           ${allListingsAsHtmlLoading}

                              <div >
                                  
                                </div>

                            </div>

                         <!-- END Section -->
          
                         <div id="product-page-pagination-container">
                          ${renderBottonNavigationAsHTML}
                          </div>
                  


                     </div>

                       <!-- END 75% Flex Section -->



      </div>

       </div>



                          <div class="safe-footer"></div>
                </center>
                        
                      
        `;

    console.log('✅ CatalogProducts built successfully.');

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () =>
      attachEventListenersCatalogProducts(lang, layoutType)
    );

    return html;
  } catch (err) {
    console.error('❌ Error building CatalogProducts:', err);
    return '<div>Error loading All products</div>';
  }
}

//function generateFilterList(items, type) {
//    return `<div class="basicTable SideBarSearchFilters-table">
//        ${items.map(item => `
//            <div class="basicTableRow SideBarSearchFilters-row">
//                <div class="basicTableCell SideBarSearchFilters-cell-checkbox">
//                    <input type="checkbox" id="${type}_${item.id}" ${item.checked ? 'checked' : ''} />
//                </div>
//                <div class="basicTableCell SideBarSearchFilters-cell-title">
//                    <label for="${type}_${item.id}">${item.name}</label>
//                </div>
//                <div class="basicTableCell SideBarSearchFilters-cell-qty">(${item.count})</div>
//            </div>
//        `).join('')}
//    </div>`;
//}

async function renderListingsHtmlLoading() {
  const countOfItems = 10; // Replace this with your actual value

  const listingCardPromises = [];

  for (let i = 0; i < countOfItems; i++) {
    const buyingCompanyID = '';
    const listingID = '';
    const skuid = '';
    const name = '';
    const builtLink = '';
    const image1FileName = '';
    const builtPrice = '';
    const abvSingle = '';
    const builtMOQ = '';
    const isProducer = '';
    const customerRating = '';
    const listingCardType = 'Lazy';

    listingCardPromises.push(
      buildComponentBasicListingCard(
        buyingCompanyID,
        listingID,
        skuid,
        name,
        builtLink,
        image1FileName,
        builtPrice,
        abvSingle,
        builtMOQ,
        isProducer,
        customerRating,
        listingCardType
      )
    );
  }

  const listingCards = await Promise.all(listingCardPromises);

  return listingCards.join('');
}

async function renderListingsHtml(listings, lang) {
  console.log('🔄 Rendering featured listings HTML');

  if (!listings || listings.length === 0) {
    return `<p>No featured listings available at the moment.</p>`;
  }
  console.log(` ${listings}`);

  const listingCards = await Promise.all(
    listings.map(async listing => {
      const buyingCompanyID = listing.buyingCompanyID;
      const listingID = listing.listingID;
      const skuid = listing.skuid;
      const name = listing.name;

      // Construct the link with the correct structure
      const builtLink = `/${lang}/${listing.departmentID}/${listing.departmentSEOPageName}/${listing.categoryID}/${listing.categorySEOPageName}/${listing.productID}/${listing.productSEOPageName}/${listing.listingID}/${listing.skuid}/${listing.seoPageName}`;

      const image1FileName = listing.image1FileName;

      const builtPrice = convertStringAmountToCurrencyAndSignDirectionForLanguage(
        listing.price,
        lang,
        appState.SiteCurrencySignSingleCookie,
        appState.SiteCurrencySignMultipleCookie,
        appState.SiteCurrencyRateCookie
      );

      const abvSingle = listing.unitOfMeasureABVSingle;
      const builtMOQ = convertNumberStringFromUKFormatToAnyLanguageFormatDouble(listing.moq, lang);
      const isProducer = listing.isProducer;
      const customerRating = listing.customerRating;
      const listingCardType = 'Basic';

      return await buildComponentBasicListingCard(
        buyingCompanyID,
        listingID,
        skuid,
        name,
        builtLink,
        image1FileName,
        builtPrice,
        abvSingle,
        builtMOQ,
        isProducer,
        customerRating,
        listingCardType
      );
    })
  );

  return listingCards.join('');
}

async function renderMainResultTopSectionAsHtmlSearch() {
  const { keySearchResults: lblSearchResults } = _tempTextTranslator;

  const html = `
     
                          
                            <h2 class="SearchResultsTitle"> ${lblSearchResults} </h2>
                                              
                      

                  

                    `;

  return html;
}

async function renderMainResultTopSectionAsHtmlProducts() {
  //const [
  //    lblAllProducts

  //] = await Promise.all([
  //    getTextTranslationByKey("keyAllProducts", lang)

  //]);

  const { keyAllProducts: lblAllProducts } = _tempTextTranslator;

  const html = `
     

      <h2 class="SearchResultsTitle"> ${lblAllProducts} </h2>



                  
                    `;

  return html;
}

async function renderMainResultTopSectionAsHtmlProduct(productNameForProduct) {
  const { keyAllProducts: lblAllProducts } = _tempTextTranslator;

  const html = `
     

      <h2 class="SearchResultsTitle"> ${productNameForProduct} </h2>



                  
                    `;

  return html;
}

async function renderMainResultTopMiddleSectionAsHtmlSearch(lang, searchString) {
  const [
    lblSearchResults,
    lblFilterBy,
    lblClearAll,
    lblCategory,
    lblSubcategory,
    lblSupplierType,
    lblSellerLevel,
    lblBuyType,
  ] = await Promise.all([
    getTextTranslationByKey('keySearchResults', lang),
    getTextTranslationByKey('keyFilterBy', lang),
  ]);

  let descriptionLabel = '';

  if (searchString === '' || !searchString) {
    descriptionLabel = 'No search term found.';
  } else {
    descriptionLabel =
      'You searched for <font color="red">' +
      '"' +
      searchString +
      '"' +
      '</font> and in total we found ' +
      '<font color="#03b5d2">' +
      totalCountOfResults +
      ' products' +
      '</font>.';
  }

  const html = `
      <div class="searchPageContainer">

                      

                            <h2 class="SearchResultsTitle"> ${lblSearchResults} </h2>
                            <div>
                               ${descriptionLabel}

                            </div>

                    
                       

                    </div>`;

  return html;
}

async function generateTopMiddleSectionWithSortingAndFiltersAsHTML(
  lblSortBy,
  lblRelevance,
  lblPriceLowToHigh,
  lblPriceHighToLow,
  lblRatings,
  lblFilters,
  lblResults
) {
  const currentSort = appState.SearchSettingsSortBy || 'relevance';

  const desktopHTML = `
    <!-- Desktop Section -->
    <div class="grid-filter-sort-search-regular-wrapper">
      <div class="search-top-product-select-grid">
        <div class="search-top-product-select-result-count-section">
          <label>
            <strong><span id="spanTotalCountOfResult">0</span></strong>
            ${lblResults}
          </label>
        </div>
        <div class="search-top-product-select-section">
          <label for="dropDownOrderBy">${lblSortBy}:</label>
          <select  class="search-page-dropdown"  name="dropDownOrderBy"  id="dropDownOrderBy"            
          >
            <option value="relevance" ${
              currentSort === 'relevance' ? 'selected' : ''
            }>${lblRelevance}</option>
            <option value="low" ${
              currentSort === 'low' ? 'selected' : ''
            }>${lblPriceLowToHigh}</option>
            <option value="high" ${
              currentSort === 'high' ? 'selected' : ''
            }>${lblPriceHighToLow}</option>
            <option value="ratings" ${
              currentSort === 'ratings' ? 'selected' : ''
            }>${lblRatings}</option>
          </select>
        </div>
      </div>
    </div>
  `;

  return `
    ${desktopHTML}
   
  `;
}

async function generateTopMiddleSectionWithSortingAndFiltersAsHTMLMobile(
  lblSortBy,
  lblRelevance,
  lblPriceLowToHigh,
  lblPriceHighToLow,
  lblRatings,
  lblFilters,
  lblResults
) {
  const mobileHTML = `
    <!-- Mobile Section -->
    <div class="grid-filter-sort-search-mobile-wrapper">
      <div class="grid-filter-sort-search-mobile">
        <button class="grid-filter-sort-search-mobile-btn">
          <label class="dropdown">
            <div class="dd-button">
              <img
                width="25"
                height="25"
                src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/sort8.svg"
                alt="sort"
              />
              ${lblSortBy}
            </div>
            <input type="checkbox" class="dd-input" id="sortDropdownToggle"/>
            <ul class="dd-menu">
                  <li data-sort="relevance">${lblRelevance}</li>
                  <li data-sort="low">${lblPriceLowToHigh}</li>
                  <li data-sort="high">${lblPriceHighToLow}</li>
                  <li data-sort="ratings">${lblRatings}</li>
            </ul>
          </label>
        </button>

        <button class="grid-filter-sort-search-mobile-btn js-show-filter-btn"  >
          <img
            width="25"
            height="25"
            src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/filter.svg"
            alt="filter"
          />
          ${lblFilters}
        </button>
      </div>
    </div>
  `;

  return `
   
    ${mobileHTML}
  `;
}

async function handleFiltersChangedSharedWithParent(lang, layoutType) {
  // console.log("Filters updated:", searchRequestModel);

  // alert("Parent post back");

  // alert(JSON.stringify(pageSpecificListOfSpecOptionsSelectedFilters));

  // Optionally scroll to top, reset pagination, etc.
  searchPageComponentSharedState.searchRequestModel.PageNumber = '1';
  await populateSearchPageWithFilters(lang, layoutType);
}

async function attachEventListenersCatalogProducts(lang, layoutType) {
  // this is the main function that attaches all the event listeners for the catalog products page
  //called once when the page is loaded

  try {
    console.log('✅ CatalogProducts event listeners attached.');

    await populateSearchPageWithFilters(lang, layoutType);

    // //main filters // side bar

    //await attachEventListenersMainSearchPageFilter(
    //     lang,
    //     searchRequestModel,
    //     layoutType,
    //     () => handleFiltersChangedSharedWithParent(lang, searchRequestModel, layoutType)
    // );
  } catch (error) {
    console.error('❌ Error attaching event listeners to CatalogProducts:', error);
  }
}

export async function populateSearchPageWithFilters(lang, layoutType) {
  const allListingsAsHtmlLoading = await renderListingsHtmlLoading();

  const productResultsDiv = document.getElementById('product-results');
  const lblSpanTotalCountOfResult = document.getElementById('spanTotalCountOfResult');

  const pagePaginationContainer = document.getElementById('product-page-pagination-container');
  const dropDownOrderBy = document.getElementById('dropDownOrderBy');

  const mainSearchContentHolderDiv = document.getElementById('mainSearchContentHolder');

  const ckGroupByListing = document.getElementById('ckGroupByListing');

  try {
    console.log('✅ CatalogProducts populating listing.');

    productResultsDiv.innerHTML = allListingsAsHtmlLoading;

    // Placeholder for future event listeners if needed

    // alert("CatalogProducts event listeners attached.");

    // Fetch  products
    const searchListingsAPIResponse = await fetchDataSearchPageWithFilters(lang);

    const allListings = searchListingsAPIResponse.listingsFound;
    const totalCountOfResults = searchListingsAPIResponse.howManyItemsFound;
    const howManyPagesFound = searchListingsAPIResponse.howManyPagesFound;

    // Update the total count of results
    lblSpanTotalCountOfResult.innerHTML = totalCountOfResults;

    const renderTopSectionAsHTML = '';

    let currentUrlForBottomNavigation = '';

    if (layoutType === 'search') {
      //  renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlSearchLoading(lang); // Set to true to render the main result to section
      currentUrlForBottomNavigation = await getLinksTranslationByKey('keySearch', lang);
    } else if (layoutType === 'allProducts') {
      // renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlProducts(lang); // Set to true to render the main result to section
      currentUrlForBottomNavigation = await getLinksTranslationByKey('keyProducts', lang); // Set to true to render the main result to section
    } else if (layoutType === 'products') {
      // renderTopSectionAsHTML = await renderMainResultTopSectionAsHtmlProduct(lang); // Set to true to render the main result to section
      currentUrlForBottomNavigation = await getLinksTranslationByKey('keyProduct', lang); // Set to true to render the main result to section
    }

    const allListingsAsHtml = await renderListingsHtml(allListings, lang);

    productResultsDiv.innerHTML = allListingsAsHtml;

    //rebuild main filters // side bar

    await attachEventListenersMainSearchPageFilter(
      lang,
      layoutType,
      async () => await handleFiltersChangedSharedWithParent(lang, layoutType)
    );

    const containerId = 'product-page-pagination-container'; // This is the ID of your pagination container div

    const renderBottonNavigationAsHTML = await buildComponentBasicBottomPagination({
      lang: lang,
      containerId: containerId, // This is the ID of your pagination container div
      itemsPerPageOptions: [1, 2, 3, 5, 6, 12, 100], // Dropdown options

      sortMethod: validateSortByValue(
        searchPageComponentSharedState.searchRequestModel.OrderByDirection
      ),
      currentUrl: currentUrlForBottomNavigation,
      currentPage: Number(searchPageComponentSharedState.searchRequestModel.PageNumber),
      currentItemsPerPage: Number(
        validateNumberOfResultsToReturnPerPage(
          searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
        )
      ),

      totalPages: Number(howManyPagesFound),

      onPageChange: newPage => {
        console.log(`Page changed to: ${newPage}`);
        // TODO: Call API to fetch data for new page

        alert('vvvv Page changed to: ' + newPage);
        //tempRefreshData();
      },
      onItemsPerPageChange: async newItemsPerPage => {
        console.log(`Items per page changed to: ${newItemsPerPage}`);
        // TODO: Call API to fetch data with new items per page

        alert('gggggggggg Page changed to: ' + newPage);
        searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage = validateNumberOfResultsToReturnPerPage(
          newItemsPerPage.toString()
        );

        //scroll mainSearchContentHolderDiv to top
        mainSearchContentHolderDiv.scrollIntoView({ behavior: 'smooth' });

        await populateSearchPageWithFilters(lang, layoutType);
      },
    });

    pagePaginationContainer.innerHTML = renderBottonNavigationAsHTML;

    // ✅ Attach event listeners after DOM is updated

    //  registerEventListenerToAttach(async () => attachEventListenersBasicBottomPagination(containerId, onItemsPerPageChange, onPageChange));

    attachEventListenersBasicBottomPagination(
      containerId,
      async newItemsPerPage => {
        //onItemsPerPageChange
        //this is the dropdown for items per page atht e bottom left

        // alert(" xxxxxxxxxxx Page changed to: " + newItemsPerPage);

        console.log(`Items per page changed to: ${newItemsPerPage}`);
        searchPageComponentSharedState.searchRequestModel.PageNumber = '1';
        searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage = validateNumberOfResultsToReturnPerPage(
          newItemsPerPage.toString()
        );

        //update app state
        setAppStateValueByKey(
          'SearchSettingsItemsPerPage',
          searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
        );

        const returnUrl = `/${currentUrlForBottomNavigation}?page=${
          searchPageComponentSharedState.searchRequestModel.PageNumber
        }&size=${
          searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
        }&sort=${validateSortByValue(
          searchPageComponentSharedState.searchRequestModel.OrderByDirection
        )}`;

        window.history.pushState({ path: returnUrl }, '', returnUrl);

        mainSearchContentHolderDiv.scrollIntoView({ behavior: 'smooth' });
        await populateSearchPageWithFilters(lang, layoutType);
      },
      async newPage => {
        //onPageChange
        //is the is the pagination buttons

        // console.log(`Page changed to: ${newPage}`);
        // alert(" cccccccccc Page changed to: " + newPage);
        searchPageComponentSharedState.searchRequestModel.PageNumber = newPage.toString();

        searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage = validateNumberOfResultsToReturnPerPage(
          searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
        );

        const returnUrl = `/${currentUrlForBottomNavigation}?page=${
          searchPageComponentSharedState.searchRequestModel.PageNumber
        }&size=${
          searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
        }&sort=${validateSortByValue(
          searchPageComponentSharedState.searchRequestModel.OrderByDirection
        )}`;

        window.history.pushState({ path: returnUrl }, '', returnUrl);

        mainSearchContentHolderDiv.scrollIntoView({ behavior: 'smooth' });
        await populateSearchPageWithFilters(lang, layoutType);
      }
    );

    //set the selected value of the dropdown

    //set the selected value of the dropdown
    dropDownOrderBy.value = validateSortByValue(
      searchPageComponentSharedState.searchRequestModel.OrderByDirection
    );

    await setupDropDownOrderByListenerForSortByDropDown(
      dropDownOrderBy,
      lang,
      layoutType,
      currentUrlForBottomNavigation
    );

    await setupMobileSortMenuListeners(lang, layoutType);

    await setupCheckBoxGroupRelatedItemsListener(
      ckGroupByListing,
      lang,
      layoutType,
      currentUrlForBottomNavigation
    );
  } catch (error) {
    console.error('❌ Error attaching event listeners to CatalogProducts:', error);

    // Handle error (e.g., show an error message)
    productResultsDiv.innerHTML = `<p>Error loading products: ${error.message}</p>`;
  }
}

export async function setupMobileSortMenuListeners(lang, layoutType) {
  document.querySelectorAll('.dd-menu li').forEach(li => {
    const onSortOptionClick = async () => {
      const sortKey = li.dataset.sort;

      setAppStateValueByKey('SearchSettingsSortBy', sortKey);
      searchPageComponentSharedState.searchRequestModel.OrderByDirection = sortKey;
      searchPageComponentSharedState.searchRequestModel.PageNumber = '1';

      const baseKey =
        layoutType === 'search'
          ? 'keySearch'
          : layoutType === 'allProducts'
          ? 'keyProducts'
          : 'keyProduct';

      const baseUrl = await getLinksTranslationByKey(baseKey, lang);
      const newUrl = `/${baseUrl}?page=1&size=${searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage}&sort=${sortKey}`;
      window.history.pushState({ path: newUrl }, '', newUrl);

      await populateSearchPageWithFilters(lang, layoutType);

      const toggle = document.getElementById('sortDropdownToggle');
      if (toggle) toggle.checked = false;
    };

    li.removeEventListener('click', onSortOptionClick);
    li.addEventListener('click', onSortOptionClick);
  });
}

//export async function setupMobileSortMenuListeners(lang, layoutType) {
//    // grab all the mobile sort <li> items
//    document.querySelectorAll('.dd-menu li').forEach(li => {
//        // clone the node to remove any previous listeners
//        const clone = li.cloneNode(true);
//        li.parentNode.replaceChild(clone, li);

//        // register via our registry
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, 'click', async () => {
//            const sortKey = clone.dataset.sort;
//            // mirror your dropdown logic
//            setAppStateValueByKey("SearchSettingsSortBy", sortKey);
//            searchPageComponentSharedState.searchRequestModel.OrderByDirection = sortKey;
//            searchPageComponentSharedState.searchRequestModel.PageNumber = "1";

//            // build and push the new URL
//            const baseKey = layoutType === "search"
//                ? "keySearch"
//                : layoutType === "allProducts"
//                    ? "keyProducts"
//                    : "keyProduct";
//            const baseUrl = await getLinksTranslationByKey(baseKey, lang);
//            const newUrl = `/${baseUrl}?page=1&size=${searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage}&sort=${sortKey}`;
//            window.history.pushState({ path: newUrl }, '', newUrl);

//            // re-render with the new sort
//            await populateSearchPageWithFilters(lang, layoutType);

//            // close the dropdown
//            const toggle = document.getElementById('sortDropdownToggle');
//            if (toggle) toggle.checked = false;
//        });
//    });
//}

function validateSortByValue(value) {
  const validValues = ['relevance', 'low', 'high', 'ratings'];
  const cleanValue = typeof value === 'string' ? value.toLowerCase() : '';

  return validValues.includes(cleanValue) ? cleanValue : 'relevance';
}

function validateNumberOfResultsToReturnPerPage(value) {
  // alert(value);

  let result = '6'; // Default value if invalid
  //convert the value to number
  const cleanValue = parseInt(value, 10);

  // Check if the value is a number and within the valid range or 1 and 100

  if (isNaN(cleanValue)) {
    result = '6'; // Default value if invalid

    //   alert("Invalid value: " + value);
  } else if (cleanValue < 1) {
    result = '6'; // Default value if invalid

    //  alert("Invalid value 2: " + value);
  } else if (cleanValue > 100) {
    result = '100'; // Default value if invalid

    //  alert("Invalid value 3: " + value);
  } else {
    result = cleanValue.toString(); // Default value if invalid
  }

  // alert(result);

  return result;
}

let dropDownSortByDropDownOrderByHandler;

export async function setupDropDownOrderByListenerForSortByDropDown(
  dropdownElement,
  lang,
  layoutType,
  currentUrlForBottomNavigation
) {
  const onDropdownChange = async e => {
    const sortByX = validateSortByValue(e.target.value);

    setAppStateValueByKey('SearchSettingsSortBy', sortByX);
    searchPageComponentSharedState.searchRequestModel.PageNumber = '1';

    const returnUrl =
      `/${currentUrlForBottomNavigation}` +
      `?page=${searchPageComponentSharedState.searchRequestModel.PageNumber}` +
      `&size=${validateNumberOfResultsToReturnPerPage(
        searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
      )}` +
      `&sort=${sortByX}`;

    window.history.pushState({ path: returnUrl }, '', returnUrl);
    searchPageComponentSharedState.searchRequestModel.OrderByDirection = sortByX;

    await populateSearchPageWithFilters(lang, layoutType);
  };

  // Prevent duplicate listeners before reattaching
  dropdownElement.removeEventListener('change', onDropdownChange);
  dropdownElement.addEventListener('change', onDropdownChange);
}

//export async function setupDropDownOrderByListenerForSortByDropDown(
//    dropdownElement,
//    lang,
//    layoutType,
//    currentUrlForBottomNavigation
//) {
//    // define (or redefine) the handler
//    dropDownSortByDropDownOrderByHandler = async function (e) {
//        const sortByX = validateSortByValue(e.target.value);

//        // update app state
//        setAppStateValueByKey("SearchSettingsSortBy", sortByX);
//        searchPageComponentSharedState.searchRequestModel.PageNumber = "1"; // reset to first page

//        const returnUrl =
//            `/${currentUrlForBottomNavigation}` +
//            `?page=${searchPageComponentSharedState.searchRequestModel.PageNumber}` +
//            `&size=${validateNumberOfResultsToReturnPerPage(
//                searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
//            )}` +
//            `&sort=${sortByX}`;

//        window.history.pushState({ path: returnUrl }, "", returnUrl);
//        searchPageComponentSharedState.searchRequestModel.OrderByDirection = sortByX;

//        await populateSearchPageWithFilters(lang, layoutType);
//    };

//    // attach via registry so it can be cleared centrally later
//    addListenerViaCurrentlyAttachedListenersRegistry(
//        dropdownElement,
//        "change",
//        dropDownSortByDropDownOrderByHandler
//    );
//}

let checkBoxGroupRelatedItemsHandler;

export async function setupCheckBoxGroupRelatedItemsListener(
  checkBoxElement,
  lang,
  layoutType,
  currentUrlForBottomNavigation
) {
  const onCheckBoxGroupChange = async e => {
    const isChecked = e.target.checked;
    searchPageComponentSharedState.searchRequestModel.GroupSearchResult = isChecked.toString();
    setAppStateValueByKey('SearchSettingsGroupRelated', isChecked);

    searchPageComponentSharedState.searchRequestModel.PageNumber = '1';
    const returnUrl =
      `/${currentUrlForBottomNavigation}` +
      `?page=${searchPageComponentSharedState.searchRequestModel.PageNumber}` +
      `&size=${validateNumberOfResultsToReturnPerPage(
        searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
      )}` +
      `&sort=${validateSortByValue(
        searchPageComponentSharedState.searchRequestModel.OrderByDirection
      )}`;

    window.history.pushState({ path: returnUrl }, '', returnUrl);

    await populateSearchPageWithFilters(lang, layoutType);
  };

  // Prevent duplicate listeners before reattaching
  checkBoxElement.removeEventListener('change', onCheckBoxGroupChange);
  checkBoxElement.addEventListener('change', onCheckBoxGroupChange);
}

//export async function setupCheckBoxGroupRelatedItemsListener(
//    checkBoxElement,
//    lang,
//    layoutType,
//    currentUrlForBottomNavigation
//) {
//    // Define the handler
//    checkBoxGroupRelatedItemsHandler = async function (e) {
//        const isChecked = e.target.checked;
//        // update shared state
//        searchPageComponentSharedState.searchRequestModel.GroupSearchResult = isChecked.toString();
//        setAppStateValueByKey("SearchSettingsGroupRelated", isChecked);

//        // reset to first page
//        searchPageComponentSharedState.searchRequestModel.PageNumber = "1";
//        const returnUrl =
//            `/${currentUrlForBottomNavigation}` +
//            `?page=${searchPageComponentSharedState.searchRequestModel.PageNumber}` +
//            `&size=${validateNumberOfResultsToReturnPerPage(
//                searchPageComponentSharedState.searchRequestModel.NumberOfResultsToReturnPerPage
//            )}` +
//            `&sort=${validateSortByValue(
//                searchPageComponentSharedState.searchRequestModel.OrderByDirection
//            )}`;

//        window.history.pushState({ path: returnUrl }, "", returnUrl);

//        // re-render with new filters
//        await populateSearchPageWithFilters(lang, layoutType);
//    };

//    // Attach via the centralized registry
//    addListenerViaCurrentlyAttachedListenersRegistry(
//        checkBoxElement,
//        "change",
//        checkBoxGroupRelatedItemsHandler
//    );
//}

export function populateSearchRequestModelFromSelectedFilters() {
  // initialize everything to null/empty
  let maxPrice = null;
  let minPrice = null;
  let minMOQ = null;
  let maxMOQ = null;

  const deptIDs = [];
  const catIDs = [];
  const productIDs = [];

  let isProducer = null;
  const sellerLevels = [];
  const unitOfMeasures = [];
  const specOptionIDs = [];
  const specIDs = [];
  const shippedFromIDs = [];
  const originIDs = [];
  const sellerCountryIDs = [];

  let canBuyNow = null;
  let canRentOrLease = null;
  let offerLogo = null;
  let offerPackaging = null;
  let offerRedesign = null;

  //check if it has both wholesaler and producer as true

  if (
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
      item => item.OptionID === 'SupplierTypeProducer'
    ) &&
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
      item => item.OptionID === 'SupplierTypeWholesaler'
    )
  ) {
    isProducer = null;
  } else if (
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
      item => item.OptionID === 'SupplierTypeProducer'
    )
  ) {
    isProducer = 'true';
  } else if (
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
      item => item.OptionID === 'SupplierTypeWholesaler'
    )
  ) {
    isProducer = 'false';
  }

  // // Supplier type
  //        case 'SupplierTypeID':

  //if (OptionID === 'SupplierTypeProducer') {
  //    isProducer = "true";
  //    // alert("Test is producer true");
  //}
  //else if (OptionID === 'SupplierTypeWholesaler') {

  //    isProducer = "false";
  //    //  alert("Test is producer false");
  //}
  //// if (OptionID === 'SupplierTypeWholesaler') supplierTypes.push('0');
  //break;

  // Walk through each selected filter
  searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.forEach(item => {
    const { SpecID, OptionID } = item;

    switch (SpecID) {
      // Departments
      case 'DeptID':
        deptIDs.push(OptionID);
        break;

      // Categories
      case 'CatID':
        catIDs.push(OptionID);
        break;

      // Products
      case 'ProductID':
        productIDs.push(OptionID);
        break;

      // Seller levels
      case 'SellerLevelID':
        if (OptionID === 'SellerLevelGold') sellerLevels.push('3');
        if (OptionID === 'SellerLevelSilver') sellerLevels.push('2');
        if (OptionID === 'SellerLevelRegular') sellerLevels.push('1', '0');
        break;

      // Buy types
      case 'BuyTypeID':
        if (OptionID === 'BuyTypeBuyNow') canBuyNow = '1';
        if (OptionID === 'BuyTypeRequestQuote') canBuyNow = '0';
        if (OptionID === 'BuyTypeLease') canRentOrLease = '1';
        break;

      // Price / MOQ
      case 'MinPriceID':
        minPrice = OptionID;
        break;
      case 'MaxPriceID':
        maxPrice = OptionID;
        break;
      case 'MinMOQID':
        minMOQ = OptionID;
        break;

      // Units
      case 'UnitOfMeasureID':
        unitOfMeasures.push(OptionID);
        break;

      // Customisation
      case 'CustomisationTypeID':
        if (OptionID === 'CustomTypeLogo') offerLogo = 'true';
        if (OptionID === 'CustomTypePackaging') offerPackaging = 'true';
        break;

      // Countries
      case 'ShippedFromCountryID':
        shippedFromIDs.push(OptionID);
        break;
      case 'CountryOfOriginID':
        originIDs.push(OptionID);
        break;
      case 'CountryOfSellerID':
        sellerCountryIDs.push(OptionID);
        break;

      default:
        // any numeric SpecID/OptionID pair goes into the generic spec lists
        if (!isNaN(+SpecID) && !isNaN(+OptionID)) {
          specOptionIDs.push(OptionID);
          specIDs.push(SpecID);
        }
        break;
    }
  });

  // Now turn all of those into comma‑separated strings exactly as your C# did:
  //searchPageComponentSharedState.searchRequestModel.MinPrice = minPrice;
  //searchPageComponentSharedState.searchRequestModel.MaxPrice = maxPrice;
  //searchPageComponentSharedState.searchRequestModel.MinMOQ = minMOQ;
  //searchPageComponentSharedState.searchRequestModel.MaxMOQ = maxMOQ;
  //searchPageComponentSharedState.searchRequestModel.ListOfDepartmentIDs = deptIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfCategoryIDs = catIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfProductIDs = productIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.IsProducer = isProducer;
  //searchPageComponentSharedState.searchRequestModel.ListOfSellerLevel = sellerLevels.join(',');
  //searchPageComponentSharedState.searchRequestModel.CanBuyNow = canBuyNow;
  //searchPageComponentSharedState.searchRequestModel.CanRentOrLease = canRentOrLease;
  //searchPageComponentSharedState.searchRequestModel.OfferCustomLogo = offerLogo;
  //searchPageComponentSharedState.searchRequestModel.OfferCustomPackaging = offerPackaging;
  //searchPageComponentSharedState.searchRequestModel.OfferProductRedesign = offerRedesign;
  //searchPageComponentSharedState.searchRequestModel.ListOfUnitOfMeasureIDs = unitOfMeasures.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfSpecOptionsIDs = specOptionIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfSpecIDs = specIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfShippedFromCountryID = shippedFromIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfCountryOfOriginID = originIDs.join(',');
  //searchPageComponentSharedState.searchRequestModel.ListOfCountryOfSellerID = sellerCountryIDs.join(',');

  // searchPageComponentSharedState.updateSearchField("MinPrice", minPrice, false);
  // searchPageComponentSharedState.updateSearchField("MaxPrice", maxPrice, false);
  //searchPageComponentSharedState.updateSearchField("MinMOQ", minMOQ, false);
  //searchPageComponentSharedState.updateSearchField("MaxMOQ", maxMOQ, false);
  //searchPageComponentSharedState.updateSearchField("ListOfDepartmentIDs", deptIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfCategoryIDs", catIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfProductIDs", productIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("IsProducer", isProducer, false);
  //searchPageComponentSharedState.updateSearchField("ListOfSellerLevel", sellerLevels.join(','), false);
  //searchPageComponentSharedState.updateSearchField("CanBuyNow", canBuyNow, false);
  //searchPageComponentSharedState.updateSearchField("CanRentOrLease", canRentOrLease, false);
  //searchPageComponentSharedState.updateSearchField("OfferCustomLogo", offerLogo, false);
  //searchPageComponentSharedState.updateSearchField("OfferCustomPackaging", offerPackaging, false);
  //searchPageComponentSharedState.updateSearchField("OfferProductRedesign", offerRedesign, false);
  //searchPageComponentSharedState.updateSearchField("ListOfUnitOfMeasureIDs", unitOfMeasures.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfSpecOptionsIDs", specOptionIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfSpecIDs", specIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfShippedFromCountryID", shippedFromIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfCountryOfOriginID", originIDs.join(','), false);
  //searchPageComponentSharedState.updateSearchField("ListOfCountryOfSellerID", sellerCountryIDs.join(','), false);

  //if (searchPageComponentSharedState.layoutType === "product") {

  //   // productIDs = searchPageComponentSharedState.currentProductID;

  //    searchPageComponentSharedState.updateSearchField("ListOfProductIDs", productIDs, false);

  //}

  searchPageComponentSharedState.updateSearchMultiple(
    {
      MinPrice: minPrice,
      MaxPrice: maxPrice,
      MinMOQ: minMOQ,
      MaxMOQ: maxMOQ,
      ListOfDepartmentIDs: deptIDs.join(','),
      ListOfCategoryIDs: catIDs.join(','),
      ListOfProductIDs: productIDs.join(','),
      IsProducer: isProducer,
      ListOfSellerLevel: sellerLevels.join(','),
      CanBuyNow: canBuyNow,
      CanRentOrLease: canRentOrLease,
      OfferCustomLogo: offerLogo,
      OfferCustomPackaging: offerPackaging,
      OfferProductRedesign: offerRedesign,
      ListOfUnitOfMeasureIDs: unitOfMeasures.join(','),
      ListOfSpecOptionsIDs: specOptionIDs.join(','),
      ListOfSpecIDs: specIDs.join(','),
      ListOfShippedFromCountryID: shippedFromIDs.join(','),
      ListOfCountryOfOriginID: originIDs.join(','),
      ListOfCountryOfSellerID: sellerCountryIDs.join(','),
    },
    false
  );

  if (searchPageComponentSharedState.layoutType === 'product') {
    //  let currentProductIDs = searchPageComponentSharedState.currentProductID;

    searchPageComponentSharedState.updateSearchField(
      'ListOfProductIDs',
      searchPageComponentSharedState.currentProductID,
      false
    );
  }

  // Finally return it (or you can just mutate in place)
  // return searchPageComponentSharedState.searchRequestModel;
}

const cacheSearchResultListing = new LRUCacheWithTTL(10, 15 * 60 * 1000); // 10 entries, 15‑minute TTL

async function fetchDataSearchPageWithFilters(lang) {
  //returns the full reponse

  //alert("fetching page main areas api");

  // alert(JSON.stringify(pageSpecificListOfSpecOptionsSelectedFilters));

  //alert(JSON.stringify(populateSearchRequestModelFromSelectedFilters(searchRequestModel, pageSpecificListOfSpecOptionsSelectedFilters)));

  // Update the searchRequestModel with the selected filters

  const emptyApiResponseForSearch = {
    howManyPagesFound: '1',
    howManyItemsFound: '0',
    listingsFound: [
      // Your listings here...
    ],
    filtersForAllResultListings: {
      howManyItemsFound: null,
      departmentsForFilter: [],
      categoriesForFilter: [],
      productsForFilter: [],
      supplierTypesForFilter: [],
      sellerLevelsForFilter: [],
    },
  };

  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listings from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("listing.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All products for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All products found for language '${lang}'`);
      //    return [];
      //}
    } else {
      populateSearchRequestModelFromSelectedFilters();

      //  alert(JSON.stringify(searchPageComponentSharedState.searchRequestModel));

      const key = JSON.stringify(searchPageComponentSharedState.searchRequestModel);
      if (cacheSearchResultListing.has(key)) {
        alert('Using cached data');
        console.log('🌐 Fetched All listings from cache');
        const cachedData = cacheSearchResultListing.get(key);
        return cachedData;
      }

      searchPageComponentSharedState.searchRequestModel.returnType = 'paged'; //"listingsID"

      //  alert(JSON.stringify(searchRequestModel));
      // prompt("searchRequestModel", JSON.stringify(searchRequestModel));

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/SearchCatalogWithFiltersAtSKULevel2024Async`;
      // const apiEndPoint = `https://localhost:7009/api/CatalogDataService/SearchCatalogWithFiltersAtSKULevel2024Async`;
      //const response = await fetch(apiEndPoint);

      const response = await fetch(apiEndPoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(searchPageComponentSharedState.searchRequestModel),
      });

      if (!response.ok) throw new Error('Failed to fetch All listings from server');

      const allListingsAndPagesInfoInfoApiResult = await response.json();

      // console.log(` ${allListingsAndPagesInfoInfoApiResult}`);

      // // Save to localStorage
      // saveToLocalStorage(storageKey, allListings);
      // saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched All listings from the server');

      cacheSearchResultListing.set(key, allListingsAndPagesInfoInfoApiResult);

      return allListingsAndPagesInfoInfoApiResult;
    }
  } catch (error) {
    console.error('❌ Error fetching listings:', error);
    return emptyApiResponseForSearch;
  }
}

async function fetchProductDetailsWithCategoryDetailsAndDepartmentDetailsByID(
  SelectedProductID,
  SelectedParentCategoryID,
  SelectedParentDepartmentID
) {
  try {
    if (isNodeEnvironment()) {
      return [];
      console.log(
        '🌐 Fetching All productDetailsWithCategoryDetailsAndDepartmentDetailsByID  from pre-built data'
      );
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All categories for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${lang}'`);
      //    return [];
      //}
    } else {
      console.log(
        '🌐 Fetching All productDetailsWithCategoryDetailsAndDepartmentDetailsByID from server'
      );

      const storageKey = `Product_${SelectedProductID}_in_subcategories_${SelectedParentCategoryID}_category_${SelectedParentDepartmentID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(
          `✅ Loaded All productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from cache`
        );
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetProductDetailsWithCategoryDetailsAndDepartmentDetailsByIDAsync?productID=${SelectedProductID}&categoryID=${SelectedParentCategoryID}&departmentID=${SelectedParentDepartmentID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from server`
        );

      const generalFinalResult = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, generalFinalResult);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(
        `🌐 Fetched All productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from the server`
      );
      return generalFinalResult;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching search product specific page productDetailsWithCategoryDetailsAndDepartmentDetailsByID',
      error
    );
    return [];
  }

  // _catalogDataService.GetProductDetailsWithCategoryDetailsAndDepartmentDetailsByIDAsync(SelectedProductID.ToString(), SelectedParentCategoryID.ToString(), SelectedParentDepartmentID.ToString(), _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);
}

export async function buildComponentMainSearchPageComponentHeaderTags() {
  //import { fetchBlogCategoryByCategoryID, fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage, fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage } from "../../services/data-services/blog-data-service.js";
  // 1. Kick off *all* dynamic imports at once, including your component
  const [{ fetchPageSEOTagsAsync }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  const currentPageSEOAPIResult = await fetchPageSEOTagsAsync('KeySearch');

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo Blog Article category not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
